import Game from './scenes/Game';
import Intro from './scenes/Intro';

export const GameShortNames = {
  regular: 'super_santa',
  jr: 'super_santa_jr'
};

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Intro, Game],

  game: GameShortNames.jr,
  STORAGE_PREFIX: 'super_santa',

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Intro.KEY,

  GameSettings: {
    NORMAL_JUMP: 222,
    WIDE_JUMP: 200,
    NORMAL_PIPE_MIN: 45,
    NORMAL_PIPE_MAX: 500,
    WIDE_PIPE_MIN: 32,
    WIDE_PIPE_MAX: 300,
    PIPE_WAIT_TIME: 3.4,

    NORMAL_GAPS: [[220, 205], [205, 190], [190, 175], [175, 160], [160, 140]],
    JR_GAPS: [[320, 305], [305, 290], [290, 275], [275, 260], [260, 240]]
  }
};
